import { createContext, useContext, useState, useEffect, type ReactNode } from 'react'
import { RateLimitDialog } from '@/components/RateLimitDialog'
import { setGlobalRateLimitDialogHandler } from '@/services/ErrorHandlerService'

interface RateLimitContextType {
  showRateLimitDialog: (message: string) => void
}

const RateLimitContext = createContext<RateLimitContextType | undefined>(undefined)

export function RateLimitProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false)
  const [message, setMessage] = useState('')

  const showRateLimitDialog = (msg: string) => {
    setMessage(msg)
    setIsOpen(true)
  }

  // Global handler'ı set et
  useEffect(() => {
    setGlobalRateLimitDialogHandler(showRateLimitDialog)
    return () => {
      setGlobalRateLimitDialogHandler(() => {})
    }
  }, [])

  return (
    <RateLimitContext.Provider value={{ showRateLimitDialog }}>
      {children}
      <RateLimitDialog 
        open={isOpen} 
        onOpenChange={setIsOpen} 
        message={message} 
      />
    </RateLimitContext.Provider>
  )
}

export function useRateLimitDialog() {
  const context = useContext(RateLimitContext)
  if (!context) {
    throw new Error('useRateLimitDialog must be used within RateLimitProvider')
  }
  return context
}

